import "./News.module.css";
import Header from "@/reusable_sections/Header";
import EduFutureKnowledgeBase from "./sections/EduFutureKnowledgeBase";
import InfoFooter from "@/reusable_sections/Footer";
export default function NewsPage() {
  return <div>
      <Header />
      <EduFutureKnowledgeBase />
      <InfoFooter />
    </div>;
}